export const BD_GET_PACKINGSTANDARD_LISTING = "BD_GET_PACKINGSTANDARD_LISTING"
export const BD_GET_PACKINGSTANDARD_LISTING_SUCCESS = "BD_GET_PACKINGSTANDARD_LISTING_SUCCESS"
export const BD_GET_PACKINGSTANDARD_LISTING_FAILED = "BD_GET_PACKINGSTANDARD_LISTING_FAILED"